import React, { Component } from "react";
import { connect } from "react-redux";
import NoteList from "./NoteList";
import _, { filter } from "lodash";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import NoteListPrint from "./NoteListPrint";
import ReactToPrint from "react-to-print";
import {
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  CustomInput,
  Alert
} from "reactstrap";

import LottieLoader from '../../../LottieLoader';
import lottieLoaderFile from '../../../../files/animation/loading.json';
import lottieWarningFile from '../../../../files/animation/ic_warning.json';
import Link from "components/ExtendLink";
import Select from "react-select";
import Datetime from "react-datetime";
import { AppointmentStatus, buildOthersSubjectOptions, CCMOnBoardingCategory, clearFollowUpSubjectsList, EHR_RPMOnBoardingCategory, followUpSubjects, MonthlyPhoneCallLeftMessage, phoneCallReminderMessage, RPMOffBoardingCategory, RPMOnBoardingCategory, scheduleFollowUpSubjectsList, ScheduledAndUnScheduledId, subjectGroupLabel, subjectOptionsList } from "../../../../constants/general.constant";
import { ROLES } from "../../../../constants/role.constant";
import DeviceImageItem from "../../../Reusable/DeviceImageItem";

class Notes extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.imageRefs = {};
    this.state = {
      activeTab: "1",
      modal: false,
      modal2: false,
      emailOffer: "",
      emailAccess: "",
      showAlertSuccess: false,
      userToSend: this.props.currentUserId,
      body: "",
      subject: "",
      isPublic: true,
      startDate: moment().subtract(90, "d").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      device: undefined,
      deviceModel: undefined,
      errorDeviceModel: false,
      ignoreDevice: true,
      hidePublicNotes: false,
      timeDuration : null,
      reminderDate : null,
      reminderDateError : undefined,
      notifyMe : ['Inbox'],
      time : null,
      timeError : null,
      error: null,
      subjectOptions : [],
      oneDayRemindMessgae : '',
      oneHourRemindMessgae : '',
      reminderEightAmUtcTodayMessage : '',
      atTheTimeRemindMessage : ''
    };
    this.toggleModal = this.toggleModal.bind(this);
    this.handleUsers = this.handleUsers.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.submit = this.submit.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.deleteInbox = this.deleteInbox.bind(this);
    this.readInbox = this.readInbox.bind(this);
    this.handleInputDateChange = this.handleInputDateChange.bind(this);
    this.handleInputReminderDateChange = this.handleInputReminderDateChange.bind(this);
    this.handelSelectChange = this.handelSelectChange.bind(this);
    this.handleTimeChange = this.handleTimeChange.bind(this);
    this.validateTime = this.validateTime.bind(this);
    this.handleSubjectInput = this.handleSubjectInput.bind(this);
    this.subjectListOfOptions = this.subjectListOfOptions.bind(this);
  }
  handleUsers = (selectedOption) => {
    this.setState({ userToSend: selectedOption });
  };
  // handle subject input field
  handleSubjectInput(event){
  if(event){
    const data = { target : {name : 'subject', ...event} }
    this.handleInputChange(data);
    if(event.value === ScheduledAndUnScheduledId.scheduled || event.value === ScheduledAndUnScheduledId.unScheduled){
       this.setState({timeDuration: "Custom Date", reminderDate : moment().add(1, 'days').format("YYYY-MM-DD"), ignoreDevice: false});
    }
    if(event.value === ScheduledAndUnScheduledId.unScheduled){
      this.setState({time : "09:00 AM", timeError : null})
    }
  }else{
    this.handleInputChange(null)
  }
  }
  handleInputChange(event) {
    if(!event){
      this.setState({
        body: "",
        subject: "",
        isPublic: true,
        reminderDate: null,
        timeDuration : null,
        reminderDateError : null,
        notifyMe : [],
        timeError : null,
        time : null,
        title : null
      });
     return;
    }
    const target = event?.target ?? null;
    const value = target && target.type && target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (value == "64620873b1cebb9c4d5b70ea" ||
        value == "646208d0b1cebb9c4d5b70eb" ||
        value == "64f02ecb6d9efff481a93e67" ||
        value == "646208d3b1cebb9c4d5b70ec" ||
        value == "646208d6b1cebb9c4d5b70ed" ||
        value == "64620ebdb1cebb9c4d5b70f7" || 
        value == "64c781a345daedcb3562a359" || 
        value == "64c781b245daedcb3562a35a" ||
        value == "65081c5b4e8e9173654eb40b" ||
        value == "65081cba4e8e9173654eb40c" ||
        value == "650a77061e37821fe76376dc" ||
        value == "667aa0e00bc7bcfe6b65aa0e" ||
        value == "6705158ac1d421c2143a8632" ||
        value == "673b0cc0ddc94130af8d513c" ||
        value == "673b0d0295dac2bd8a709055" ||
        value == "673b0d7cddc94130af8d513e" ||
        value == "675c171c95826b52e5e689ec" ||
        value == "675c1a1295826b52e5e689ed" ||
        value == "6911b697c4084353e779ac5c" ||
        value == "6911b7dfc4084353e779ac5e"
      ) {
            this.setState({
              ignoreDevice: false,
              title: this.props.onBoardingStatus ? _.find(this.props.onBoardingStatus, v => v._id === value) ? (_.find(this.props.onBoardingStatus, v => v._id === value)).title : "" : "",
              body: this.props.onBoardingStatus ? _.find(this.props.onBoardingStatus, v => v._id === value) ? (_.find(this.props.onBoardingStatus, v => v._id === value)).message : " " : "",
              deviceModel: undefined,
              device: undefined,
            });
            this.props.dispatch({
              type: "DO_GET_ALL_DEVICE_FOR_ON_BOARDING",
              payload :{
                user: this.state.userToSend,
                category: value
              }
            });
    } else {
      if (name === "subject" && value === MonthlyPhoneCallLeftMessage.subject) {
        this.setState({
          body: MonthlyPhoneCallLeftMessage.message,
          ignoreDevice: true,
          title: ""
        });
      } else if (name == "subject") {
        this.setState({
           body : "",
           ignoreDevice: true,
           title : null,
        })
      }
    }
    this.setState({
      [name]: value      
    }, () => {
      var today = moment();
      let reminderDate;
      if(name == 'timeDuration'){
        if (this.state.timeDuration == 'One Week') {
          reminderDate = today.add(7, 'days').format("YYYY-MM-DD");
          this.setState({reminderDate : reminderDate}, () => this.validateTime())
        } else if (this.state.timeDuration == 'Two Weeks') {
          reminderDate = today.add(2, 'weeks').format("YYYY-MM-DD");
          this.setState({reminderDate : reminderDate}, () => this.validateTime())
        } else if (this.state.timeDuration == 'One Month') {
          reminderDate = today.add(1, 'months').format("YYYY-MM-DD");
          this.setState({reminderDate : reminderDate}, () => this.validateTime())
        }else if (this.state.timeDuration == 'Custom Date') {
          reminderDate = today.format("YYYY-MM-DD");
          this.setState({reminderDate : reminderDate}, () => this.validateTime())
        }
      }
    });
    if (name == "startDate" || name == "endDate") {
      if (this.props.datesForNotes) {
        this.props.datesForNotes({
          [name + "ForNotes"]: value
        });
      }
    }
    if (name == "subject") {
      if (value == "64620873b1cebb9c4d5b70ea" ||
        value == "646208d0b1cebb9c4d5b70eb" ||
        value == "64f02ecb6d9efff481a93e67" ||
        value == "646208d3b1cebb9c4d5b70ec" ||
        value == "646208d6b1cebb9c4d5b70ed" ||
        value == "64620ebdb1cebb9c4d5b70f7" ||
        value == "64c781a345daedcb3562a359" ||
        value == "64c781b245daedcb3562a35a" ||
        value == "65081c5b4e8e9173654eb40b" ||
        value == "65081cba4e8e9173654eb40c" ||
        value == "650a77061e37821fe76376dc" || 
        value == "Patient was recently admitted to the Hospital" ||
        value == "WINS - Positive Outcome" ||
        value == followUpSubjects.followUpReminder ||
        value == followUpSubjects.followUpReminderCompleted ||
        value == followUpSubjects.followUpPhoneCallCompleted ||
        value == "667aa0e00bc7bcfe6b65aa0e" ||
        value == "6705158ac1d421c2143a8632" ||
        value == "673b0d7cddc94130af8d513e" ||
        value == "673b0d0295dac2bd8a709055" ||
        value == "673b0cc0ddc94130af8d513c" ||
        value == "675c171c95826b52e5e689ec" ||
        value == "675c1a1295826b52e5e689ed" ||
        value == followUpSubjects.followUpPhoneCall ||
        value == MonthlyPhoneCallLeftMessage.subject ||
        value == "6911b7dfc4084353e779ac5e" ||
        value == "6911b697c4084353e779ac5c") {
        this.setState({
          hidePublicNotes: true,
          isPublic:true
        });
      } else {
        this.setState({
          hidePublicNotes: false,
        });
      }
    }
    if(name == "subject" && this.state.subject !== value && (value == followUpSubjects.followUpReminder  || value == followUpSubjects.followUpPhoneCall)){
      this.setState({body : ''})
    }
    if(name == "subject" && (value !== followUpSubjects.followUpReminder  && value !== followUpSubjects.followUpPhoneCall)){
      this.setState({
      timeDuration : null,
      reminderDate : null,
      reminderDateError : undefined,
      notifyMe : ['Inbox'],
      time : null, 
      timeError : null
    })
    }
    if(value == "667aa0e00bc7bcfe6b65aa0e"){
      this.setState({ignoreDevice: true})
    }
  }
  handelSelectChange(event){
    const notifyMe = this.state.notifyMe;
    if(notifyMe.length == 0){
      notifyMe.push('Inbox')
    }
    const target = event.target;
    const value = target.checked;
    const name = target.name;
    if(value && target && (target.value == 'Sms' || target && target.value == 'Email') && name == 'notifyMe'){
      notifyMe.push(event.target.value)
    }else if(!value && name == 'notifyMe'){
     let index = notifyMe.indexOf(target.value);
     notifyMe.splice(index, 1);
    }
    let uniqueArray = _.uniq(notifyMe);
    this.setState({notifyMe: uniqueArray})
  }
  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
    if(this.state.title){
     const onBoardingNote = _.find(this.props.onBoardingStatus, v => v.title === this.state.title)._id;
     if(onBoardingNote){
      this.props.dispatch({
        type: "DO_GET_ALL_DEVICE_FOR_ON_BOARDING",
        payload :{
          user: this.state.userToSend,
          category: onBoardingNote
        }
      });
     }
    }
    // this.resetForm()
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }
  resetForm() {
    this.setState({
      modal: !this.state.modal,
      body: "",
      subject: "",
      isPublic: true,
      reminderDate: null,
      timeDuration : null,
      reminderDateError : null,
      notifyMe : [],
      timeError : null,
      time : null,
      title : null,
      oneDayRemindMessgae : '',
      oneHourRemindMessgae : '',
      reminderEightAmUtcTodayMessage : '',
      atTheTimeRemindMessage : '',
      deviceModel: undefined
    });
    this.props.dispatch({
      type: "GENERIC_ERROR"
    });
  }
  deleteInbox(id) {
    this.props.dispatch({
      type: "DO_DELETE_USER_NOTES",
      payload: {
        id: id
      }
    });
    setTimeout(() => {
      this.props.dispatch({
        type: "DO_GET_USER_NOTES",
        payload: { userid: this.props.currentUserId }
      });
    }, 1500);
  }
  readInbox(id) {
    this.props.dispatch({
      type: "DO_READ_NOTES",
      payload: {
        id: id
      }
    });
    this.props.dispatch({
      type: "DO_GET_NOTES"
    });
  }
  submit(e) {
    e.preventDefault();
    if(!this.state.subject){
      this.setState({
        error: {
          message: "Please select subject",
          type: "subject", // Identifies which field the error is for
        }
      });
     return;
    }else if(!this.state.body){
      this.setState({error : {
        message : "Please enter message",
        type: "body"
      }
      })
     return;
    }else{
      this.setState({
        error : null
      })
    }
    const valid =  this.validateTime();
    if(this.state.reminderDateError || this.state.timeError || valid){
      return;
    }
    const formData = new FormData();
    formData.append("user", this.state.userToSend);
    formData.append("body", this.state.body);
    formData.append("subject", this.state.subject === "Other" ? this.state.customSubject : this.state.subject);
    formData.append("isPublic", this.state.isPublic);

    // title add on based on subject select
    if(this.state.subject == "64620873b1cebb9c4d5b70ea" ||
      this.state.subject == "646208d0b1cebb9c4d5b70eb" ||
      this.state.subject == "64f02ecb6d9efff481a93e67" ||
      this.state.subject == "646208d3b1cebb9c4d5b70ec" ||
      this.state.subject == "646208d6b1cebb9c4d5b70ed" ||
      this.state.subject == "64620ebdb1cebb9c4d5b70f7" || 
      this.state.subject == "64c781a345daedcb3562a359" || 
      this.state.subject == "64c781b245daedcb3562a35a" ||
      this.state.subject == "65081c5b4e8e9173654eb40b" ||
      this.state.subject == "65081cba4e8e9173654eb40c" ||
      this.state.subject == "650a77061e37821fe76376dc" ||
      this.state.subject == "667aa0e00bc7bcfe6b65aa0e" ||
      this.state.subject == "6705158ac1d421c2143a8632" ||
      this.state.subject == "673b0d7cddc94130af8d513e" ||
      this.state.subject == "673b0d0295dac2bd8a709055" ||
      this.state.subject == "673b0cc0ddc94130af8d513c" ||
      this.state.subject == "675c171c95826b52e5e689ec" ||
      this.state.subject == "675c1a1295826b52e5e689ed" ||
      this.state.subject == "6911b697c4084353e779ac5c" ||
      this.state.subject == "6911b7dfc4084353e779ac5e"
    ){
      if (_.isEmpty(this.state.title)) {
        return;
      }
      formData.append("title", this.state.title);
    }
    if(this.props.hideNotesButton){
       formData.append("patientPath", true);
    }else{
      if(this.state.deviceModel && this.state.deviceModel.length > 0){
        formData.append("device", JSON.stringify(this.state.deviceModel));
      }
    }
    const notifyMe = this.state.notifyMe
    if(notifyMe.length == 0){
      notifyMe.push('Inbox')
    }
    if(this.state.reminderDate && (this.state.subject == followUpSubjects.followUpReminder || this.state.subject == followUpSubjects.followUpPhoneCall || this.state.subject == ScheduledAndUnScheduledId.scheduled || this.state.subject == ScheduledAndUnScheduledId.unScheduled)){
      const timeMoment = moment(this.state.time, "hh:mm A");
      const reminderSentDate = moment(`${this.state.reminderDate}`).set({hour:moment(timeMoment).hour(),minute:moment(timeMoment).minutes(),second:0,millisecond:0});
      // add time in reminderSentDate varible this time is a cron run this time
      const reminderWithTime = reminderSentDate.utc();
      //  1 day before reminder date
      const reminderOneDayBeforeSentDate = moment(`${this.state.reminderDate}`).set({hour:moment(timeMoment).hour(),minute:moment(timeMoment).minutes(),second:0,millisecond:0}).subtract(1, 'days'); // Subtract 1 day from the date;
        // add time in reminderSentDate varible this time is a cron run this time
      const reminderOneDayBeforeWithTime = reminderOneDayBeforeSentDate.utc();
      
      // 1 hour before reminder date
      const reminderOneHourBeforeSentDate = moment(`${this.state.reminderDate}`).set({hour:moment(timeMoment).hour(),minute:moment(timeMoment).minutes(),second:0,millisecond:0}).subtract(1, 'hour'); // Subtract 1 hour from the reminderSentDate;
        // add time in reminderSentDate varible this time is a cron run this time
      const reminderOneHourBeforeWithTime = reminderOneHourBeforeSentDate.utc();
     
      // Thirty Minute before reminder date
      // const reminderThirtyMinuteBeforeSentDate = moment(`${this.state.reminderDate}`).set({hour:moment(selectedTime).hour(),minute:moment(selectedTime).minutes(),second:0,millisecond:0}).subtract(1, 'hour').add(30, 'minutes'); // Subtract 1 hour from the reminderSentDate;
      // set UTC 8:00 AM static time
      const reminderEightAmUtcToday = moment.utc(this.state.reminderDate).set({
        hour: 12,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      const reminderNineAmUtcToday = moment.utc(this.state.reminderDate).set({
        hour: 14,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      const reminderNoteData = {
        reminderDate : reminderWithTime, 
        status : 'Reminder',
        timeDuration : this.state.timeDuration,
        notifyMe : notifyMe,
        timeZone : moment.tz.guess(),
        time : this.state.time,
      }
      const currentUtcTime = moment().utc(); // Current time in UTC
      if(this.state.subject == followUpSubjects.followUpPhoneCall){
      if(!(currentUtcTime.isAfter(reminderOneHourBeforeWithTime))){
        reminderNoteData.reminderOneHourBeforeDate = reminderOneHourBeforeWithTime;
      }
      if(!(moment().startOf('day').isSame(moment(this.state.reminderDate).startOf('day'), 'day') && (moment().utc().isAfter(moment().utc().startOf('day').add(12, 'hours'))))){
        reminderNoteData.reminderEightAmUtcToday = reminderEightAmUtcToday;
      }
      if(!(currentUtcTime.isAfter(reminderOneDayBeforeWithTime))){
        reminderNoteData.reminderOneDayBeforeDate = reminderOneDayBeforeWithTime;
      }
      // set reminder message in the payload
      if(this.state.atTheTimeRemindMessage){
        reminderNoteData.atTheTimeRemindMessage = this.state.atTheTimeRemindMessage;
      }
      if(this.state.reminderEightAmUtcTodayMessage){
        reminderNoteData.reminderEightAmUtcTodayMessage = this.state.reminderEightAmUtcTodayMessage;
      }
      if(this.state.oneDayRemindMessgae && !(currentUtcTime.isAfter(reminderOneDayBeforeWithTime))){
        reminderNoteData.oneDayRemindMessgae = this.state.oneDayRemindMessgae;
      }
      if(this.state.oneHourRemindMessgae){
        reminderNoteData.oneHourRemindMessgae = this.state.oneHourRemindMessgae;
      }
      formData.delete("title");
      }
      if(this.state.subject === ScheduledAndUnScheduledId.scheduled || this.state.subject === ScheduledAndUnScheduledId.unScheduled){
      if(!(currentUtcTime.isAfter(reminderOneHourBeforeWithTime))){
        reminderNoteData.reminderOneHourBeforeDate = reminderOneHourBeforeWithTime;
        reminderNoteData.appointmentStatus = AppointmentStatus.appointmentScheduled;
      }
      if(this.state.subject === ScheduledAndUnScheduledId.unScheduled){
        if (!(currentUtcTime.isAfter(reminderNineAmUtcToday))) {
          reminderNoteData.reminderNineAmDate = reminderNineAmUtcToday;
          reminderNoteData.appointmentStatus = AppointmentStatus.appointmentScheduled;
        } else {
          reminderNoteData.reminderNineAmDate = reminderNineAmUtcToday;
          reminderNoteData.appointmentStatus = AppointmentStatus.appointmentCompleted;
        }
      }
      }
      formData.append("reminderNoteData", JSON.stringify(reminderNoteData));
    }
    // payload add scheduled date and time pass
    if (this.props.hideNotesButton) {
      this.props.dispatch({
        type: "DO_SAVE_USER_NOTES",
        payload: formData
      });
      setTimeout(() => {
        this.props.dispatch({
          type: "DO_GET_USER_NOTES",
          payload: { userid: this.props.currentUserId, patientPath: true }
        });
      }, 1500);
    } else {
      if(!this.state.ignoreDevice && this.props.onBoarding && this.props.onBoarding.length == 0){
        this.setState({
          errorDeviceModel: true
        });
        return;
      }
      if(!this.state.ignoreDevice && ((!this.state.deviceModel) || (this.state.deviceModel && this.state.deviceModel.length == 0)) && !this.props.isNotApplicable){
        this.setState({
          errorDeviceModel: true
        });
        return;
      }
      this.props.dispatch({
        type: "DO_SAVE_USER_NOTES",
        payload: formData
      });
      setTimeout(() => {
        this.setState({
          startDate:"",
          endDate:"",
        }, () => {
          this.fetchData();
        });
      }, 400);
    }
    this.resetForm();
  }
  componentDidMount() {
    this.subjectListOfOptions()
    this.props.dispatch({
      type: "DO_GET_ON_BOARDING_STATUS",
    });
    if (this.props.hideNotesButton) {
      this.props.dispatch({
        type: "DO_GET_USER_NOTES",
        payload: { userid: this.props.currentUserId, patientPath: true }
      });
    } else {
      this.setState({
        startDate:"",
        endDate:"",        
      }, () => {
        this.fetchData();
      });
    }
  }
  fetchData(){
    this.props.dispatch({
      type: "DO_GET_USER_NOTES",
      payload: { 
        userid: this.props.currentUserId
      },    
    });
  }
  handleInputDateChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState(
      { [name]: value }, () => {
        this.isEndDateValid(this.state.endDate)
      }
    );   
  }
  isEndDateValid(value) {
    if (value === undefined || value === null || value.trim().length == 0) {
      this.setState({
        endDateError: undefined
      });
      return false;
    } else {
      var date = moment(new Date(this.state.startDate), 'MM/DD/YYYY');
      date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      var dateEntered = new Date(value);
      var today = moment(date, 'MM/DD/YYYY');
      var enteredDate = moment(dateEntered, 'MM/DD/YYYY');
      var dDiff = today.isSameOrAfter(enteredDate);
      if (dDiff) {
        this.setState({
          endDateError: "Please select end date is greater than equal to start date."
        });
        return false;
      } else if (today.isSame(enteredDate)) {
        this.setState({
          endDateError: undefined
        });
        return true;
      } else {
        this.setState({
          endDateError: undefined
        });
        return true;
      }
    }
  };
  handleInputReminderDateChange(event){
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState(
      { [name]: value }, () => {
        this.validDateValiadation(this.state.reminderDate)
        this.validateTime()
      }
    );   
  }
  validDateValiadation(date ){
    const todayDate = moment().format('YYYY-MM-DD');
    let startDate;
    if(date){
      startDate = moment(date).format('YYYY-MM-DD');
    }
   let errorFlag = false;
   if(startDate < todayDate){
      errorFlag = true;
      this.setState({ reminderDateError: "Please select Date greater or equal to Today's Date" });
    }

  if(!errorFlag){
    this.setState({
      reminderDateError: undefined
    });
  }
  }
  handleTimeChange(event) {
    const validTime =  moment(event, 'hh:mm A', true).isValid();
    if(!validTime){
      this.setState({timeError : 'Invalid time format. Please use "hh:mm AM/PM"'});
      return
    }
    let time = event.format("hh:mm A");
    this.setState({time : time, timeError : null}, () => this.validateTime())
  }
  validateTime(){
    const todayDate = moment().format('YYYY-MM-DD');
    if(this.state.reminderDate < todayDate){
      this.setState({ reminderDateError: "Please select Date greater or equal to Today's Date" });
      if(this.state.time){
        this.setState({timeError : 'The time is not valid. Please select correct Date'});
      }else{
        this.setState({timeError : null});
      }
      return true
    }else{
      this.setState({ reminderDateError: null, timeError : null });
    }
    if(this.state.timeDuration == "Custom Date" && this.state.reminderDate <= todayDate){
      if(moment(this.state.reminderDate).isSame(todayDate) && this.state.time){
        const selectedTime = moment(this.state.time, 'hh:mm A');
        const reminderSentDate = moment(`${this.state.reminderDate}`).set({hour:moment(selectedTime).hour(),minute:moment(selectedTime).minutes(),second:0,millisecond:0}).format('YYYY-MM-DD HH:mm');
        const todayDateTime = moment().format('YYYY-MM-DD HH:mm');
        const oneHourLater =  moment().add(1, 'hours');
        const nonScheduledDate = moment(`${this.state.reminderDate}`).format('YYYY-MM-DD');
        const todayDate = moment().format('YYYY-MM-DD');
        if (this.state.subject.toString() === ScheduledAndUnScheduledId.unScheduled.toString()) {
          if (moment(nonScheduledDate).isBefore(todayDate)) {
            this.setState({ timeError: "Please select the Time greater than Today's Time" });
            return true
          }
        } else{
        if(this.state.subject == followUpSubjects.followUpPhoneCall && moment(reminderSentDate).isBefore(oneHourLater)){
          this.setState({timeError : "Reminder must be sent at least 1 hour after the current time"});
          return true
        }else if(!moment(reminderSentDate).isAfter(todayDateTime)){
          this.setState({timeError : "Please select the Time greater than Today's Time"});
          return true
        } else{
          this.setState({timeError : null});
        }
        }
      }else{
        this.setState({timeError : null});
      }
    }else{
      this.setState({timeError : null });
    }
    this.reminderMessageUpdate()
  }
  reminderMessageUpdate(){
  if(this.state.time && !this.state.timeError && this.state.reminderDate){
    let { oneDayRemindMessgae, oneHourRemindMessgae, reminderEightAmUtcTodayMessage, atTheTimeRemindMessage} = phoneCallReminderMessage;
    let patientName = this.props.notesPatientDetails && this.props.notesPatientDetails.fname && this.props.notesPatientDetails.lname ? this.props.notesPatientDetails.fname + " " +  this.props.notesPatientDetails.lname  : '';
    let organizationName = this.props.notesPatientDetails && this.props.notesPatientDetails.mainCareProvider && this.props.notesPatientDetails.mainCareProvider.organization ? this.props.notesPatientDetails.mainCareProvider.organization : 'My Vital View';
    let providerName = this.props.currentUserDetails && this.props.currentUserDetails.fname && this.props.currentUserDetails.lname  ? this.props.currentUserDetails.fname  + " " + this.props.currentUserDetails.lname  : '';
    let time = moment(this.state.time, "h:mm A", true).format("h:mm A");
    let oneDayTime = `tomorrow at ${time}`;
    let oneHourTime = `today at ${time}`;
    let patientPhone = this.props.notesPatientDetails && this.props.notesPatientDetails.phone && this.props.notesPatientDetails.phone !== "0" ? `at ${this.props.notesPatientDetails.phone}` : '';
    let staffName = this.props.currentUserDetails && this.props.currentUserDetails.fname && this.props.currentUserDetails.lname  ? this.props.currentUserDetails.fname + " " + this.props.currentUserDetails.lname  : '';
    if(this.props.currentUserDetails && this.props.currentUserDetails.role == ROLES.admin){
      organizationName = "My Vital View";
      providerName = ''
    }
    if(oneDayRemindMessgae && !moment().startOf('day').isSame(moment(this.state.reminderDate).startOf('day'), 'day')){
      oneDayRemindMessgae = oneDayRemindMessgae.replace("${Patient Name}", patientName)
      .replace("${Organization}", organizationName)
      .replace("${time}", oneDayTime);

      if (providerName) {
        oneDayRemindMessgae = oneDayRemindMessgae.replace("${Staff Name}", providerName);
      } else {
        // Remove placeholder and any extra space before it (like " ${Staff Name}" or " ${Staff Name}," etc.)
        oneDayRemindMessgae = oneDayRemindMessgae.replace(/ ?\${Staff Name}[,]*/g, '');
      }
      this.setState({oneDayRemindMessgae : oneDayRemindMessgae})
    }
    if(oneHourRemindMessgae){
      oneHourRemindMessgae = oneHourRemindMessgae.replace("${Patient Name}", patientName)
      .replace("${Organization}", organizationName)
      .replace("${time}", oneHourTime);

      if (providerName) {
        oneHourRemindMessgae = oneHourRemindMessgae.replace("${Staff Name}", providerName);
      } else {
        // Remove placeholder and any extra space before it (like " ${Staff Name}" or " ${Staff Name}," etc.)
        oneHourRemindMessgae = oneHourRemindMessgae.replace(/ ?\${Staff Name}[,]*/g, '');
      }
      this.setState({oneHourRemindMessgae : oneHourRemindMessgae})
    }
    if(reminderEightAmUtcTodayMessage){
      reminderEightAmUtcTodayMessage = reminderEightAmUtcTodayMessage.replace("${Patient Name}", patientName)
      .replace("${Staff Name}", staffName)
      .replace("${Organization}", organizationName)
      .replace("${time}", oneHourTime)

      if (patientPhone) {
        reminderEightAmUtcTodayMessage = reminderEightAmUtcTodayMessage.replace("${Patient Phone Number}", patientPhone);
      } else {
        // Remove placeholder and any extra space before it (like " ${Staff Name}" or " ${Staff Name}," etc.)
        reminderEightAmUtcTodayMessage = reminderEightAmUtcTodayMessage.replace(/ ?\${Patient Phone Number}[,]*/g, '');
      }
      this.setState({reminderEightAmUtcTodayMessage : reminderEightAmUtcTodayMessage})
    }
    if(atTheTimeRemindMessage){
      atTheTimeRemindMessage = atTheTimeRemindMessage.replace("${Patient Name}", patientName)
      .replace("${Staff Name}", staffName)
      .replace("${Organization}", organizationName)
      .replace("${time}", oneHourTime);

      if (patientPhone) {
        atTheTimeRemindMessage = atTheTimeRemindMessage.replace("${Patient Phone Number}", patientPhone);
      } else {
        // Remove placeholder and any extra space before it (like " ${Staff Name}" or " ${Staff Name}," etc.)
        atTheTimeRemindMessage = atTheTimeRemindMessage.replace(/ ?\${Patient Phone Number}[,]*/g, '');
      }
      this.setState({atTheTimeRemindMessage : atTheTimeRemindMessage})
    }
  }
  }
  componentDidUpdate(prevProps) {
    if (this.props.onBoardingStatus !== prevProps.onBoardingStatus) {
      this.subjectListOfOptions();
    }
  }
  subjectListOfOptions(){
    const subjectOptions = [];
    // RPM onBoarding options group
    const RPMOnBoardingCategoryOptions = [];
    RPMOnBoardingCategory.map((item) => {
      const findCategory = this.props.onBoardingStatus && this.props.onBoardingStatus.find((element) => element._id == item);
      if(findCategory){
        RPMOnBoardingCategoryOptions.push({ value: findCategory._id, label: findCategory.title || "No title" })
      }
    })
    subjectOptions.push({
      label: subjectGroupLabel.RPMOnBoarding,
      options: RPMOnBoardingCategoryOptions
    })
    // EHR RPM onBoarding options group
    const EHR_RPMOnBoardingCategoryOptions = [];
    EHR_RPMOnBoardingCategory.map((item) => {
      const findCategory = this.props.onBoardingStatus && this.props.onBoardingStatus.find((element) => element._id == item);
      if(findCategory){
        EHR_RPMOnBoardingCategoryOptions.push({ value: findCategory._id, label: findCategory.title || "No title" })
      }
    })
    subjectOptions.push({
      label: subjectGroupLabel.EHR_RPMOnBoarding,
      options: EHR_RPMOnBoardingCategoryOptions
    })
    // RPMOffBoarding options group
    const RPMOffBoardingCategoryOptions = [];
    RPMOffBoardingCategory.map((item) => {
      const findCategory = this.props.onBoardingStatus && this.props.onBoardingStatus.find((element) => element._id == item);
      if(findCategory){
        RPMOffBoardingCategoryOptions.push({ value: findCategory._id, label: findCategory.title || "No title" })
      }
    })
    subjectOptions.push({
      label: subjectGroupLabel.RPMOffBoarding,
      options: RPMOffBoardingCategoryOptions
    })
    // CCMonBoarding options group
    const CCMOnBoardingCategoryOptions = [];
    CCMOnBoardingCategory.map((item) => {
      const findCategory = this.props.onBoardingStatus && this.props.onBoardingStatus.find((element) => element._id == item);
      if(findCategory){
      CCMOnBoardingCategoryOptions.push({ value: findCategory._id, label: findCategory.title || "No title" })
      }
    })
    subjectOptions.push({
      label: subjectGroupLabel.CCMOnBoarding,
      options: CCMOnBoardingCategoryOptions
    })
    // Notes that schedule a follow up
    subjectOptions.push({
      label: subjectGroupLabel.scheduleFollowUp,
      options: scheduleFollowUpSubjectsList
    })
    // Notes that clear the follow up reminders
    subjectOptions.push({
      label: subjectGroupLabel.clearFollowUp,
      options: clearFollowUpSubjectsList
    })
    // Other options group
    subjectOptions.push({
      label: subjectGroupLabel.others,
      options: buildOthersSubjectOptions(subjectOptionsList)
    })
    this.setState({subjectOptions : subjectOptions})
  }
  render() {
    var properStartDate = this.state.startDate ? moment(this.state.startDate).startOf("day").format() : undefined;
    var properEndDate = this.state.endDate? moment(this.state.endDate).endOf("day").format() : undefined;
    var filteredNotes = []
    if(this.state.endDateError != undefined || (properStartDate == undefined && properEndDate == undefined)){
      properEndDate = undefined;
    } 
    var filteredNotes = filter(this.props.notes, function (value) {
      const convertFirst = moment(value.createdAt).format();      
      if(properStartDate && properEndDate){
        return moment(convertFirst).isBetween(properStartDate, properEndDate);    
      }else if(properStartDate) {
        return moment(convertFirst).isAfter(properStartDate);    
      }else if(properEndDate) {
        return moment(convertFirst).isBefore(properEndDate);    
      } else {
        return true;
      } 
    });
    return (
      <div>
        <div>
          <Row>
          <Col md={2} style={{marginTop:5}}>
              <FormGroup className="remove-bottom-margin form-group-patient">
                <Label for="exampleEmail">Filter By Start Date</Label>
                <Input
                  className="input-date-filter remove-bottom-margin"
                  type="date"
                  name="startDate"
                  max={moment().format("YYYY-MM-DD")}
                  onChange={this.handleInputDateChange}
                  value={this.state.startDate}
                />
              </FormGroup>
            </Col>
            <Col md={2}>
              <FormGroup className="remove-bottom-margin form-group-patient">
                <Label for="examplePassword">Filter By End Date</Label>
                <Input
                  className="input-date-filter remove-bottom-margin"
                  type="date"
                  name="endDate"
                  max={moment().format("YYYY-MM-DD")}
                  onChange={this.handleInputDateChange}
                  value={this.state.endDate}
                />
                <Label
                  style={{
                    color: "red",
                    textAlign: "left",
                    padding: 5
                  }}>{this.state.endDateError}</Label>
              </FormGroup>
            </Col>
            <Col md={8} style={{marginTop:10}}>
              {(this.props.isCareProvider || this.props.isStaff) && (
                <>
                  <Link
                    style={{ margin: 5 }}
                    to={`/onboarding`}
                    className="btn pull-right on-boarding-note-click-cls link-padding-on-boarding">
                    <i className="mdi mdi-account-card-details"></i> RPM On-Boarding
                  </Link>
                  <Link
                    style={{ margin: 5 }}
                    to={`/onboardingccm`}
                    className="btn pull-right on-boarding-ccm-note-click-cls link-padding-on-boarding">
                    <i class="mdi mdi-account-card-details"></i> CCM On-Boarding
                  </Link>
                  <Link
                  style={{ margin: 5 }}
                    to={`/offboarding`}
                    className="btn pull-right off-boarding-note-click-cls link-padding-on-boarding">
                    <i class="mdi mdi-account-card-details"></i> RPM Off-Boarding
                  </Link>
                </>
              )}
              <ReactToPrint
                documentTitle={"Notes"}
                trigger={() => (
                  <div className="pull-right">
                    <button
                      className="btn btn-info ml-2 print-click-cls"
                      style={{ float: 'right', margin: 5, padding: "10px 26px" }}
                    >
                      <i class="mdi mdi-cloud-print"></i>
                      Print
                    </button>
                  </div>
                )}
                content={() => this.componentRef}
              />
              <button
                className="btn btn-info ml-2 create-note-click-cls"
                style={{ float: 'right', margin: 5 }}
                onClick={() => {
                  this.toggleModal();
                }}
              >
                <i class="mdi mdi-note btn-icon-prependd"></i>
                Create a Note
              </button>
            </Col>
          </Row>
        </div>
        {this.props.ongoingNoteListRequest && (
          <NoteList
            deleteInbox={this.deleteInbox}
            readInbox={this.readInbox}
            loading={this.props.ongoingNoteListRequest}
            notes={[]}
          />
        )}
        {!this.props.ongoingNoteListRequest && this.props.notes && (
          <NoteList
            deleteInbox={this.deleteInbox}
            readInbox={this.readInbox}
            loading={this.props.ongoingNoteListRequest}
            notes={filteredNotes}
          />
        )}
        {this.props.notes && (
          <div className="hide">
            <NoteListPrint
              ref={el => (this.componentRef = el)}
              deleteInbox={this.deleteInbox}
              readInbox={this.readInbox}
              loading={this.props.ongoingRequest}
              notes={filteredNotes}         
              notesPatientDetails={this.props.notesPatientDetails}
              latestReadingUser={this.props.latestReadingUser}
              rpmTotalDuration={this.props.rpmTotalDuration}
              ccmTotalDuration={this.props.ccmTotalDuration}
            />
          </div>
        )}
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggleModal}
          className={this.props.className}
          size={this.state.subject == followUpSubjects.followUpPhoneCall && this.state.time ? "lg" : "" } 
        >
          <ModalHeader toggle={this.toggleModal}>Create a Note</ModalHeader>

          <ModalBody className="bg-white">
            <Form onSubmit={this.submit}>
            <div className={this.state.subject == followUpSubjects.followUpPhoneCall && this.state.time ? "row" : ""}>
            <div className={this.state.subject == followUpSubjects.followUpPhoneCall && this.state.time ? "col-md-6" : ""}>
              <FormGroup>
                <Label for="exampleSelect">Subject</Label>
                {this.props.onBoardingStatus && _.size(this.props.onBoardingStatus) > 0 && (
                  <Select
                  options={this.state.subjectOptions}
                  // name="subject"
                  onChange={this.handleSubjectInput}
                  value={this.state.subjectOptions.map((item) => item.options.find((element) => this.state.subject == element.value)) || ''}
                  // isSearchable={true}
                  isClearable={true}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: '100%', // Full width of the container
                    }),
                    option: (provided) => ({
                      ...provided,
                      whiteSpace: 'normal', // Text wraps in the dropdown
                      wordWrap: 'break-word', // Break words if needed
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                  }}
                />
                )}
                {this.state.error && this.state.error.type == 'subject' && !this.state.subject && (
                  <Label
                  style={{
                    color: "red",
                    textAlign: "left",
                    paddingTop: '3px'
                  }}>{this.state.error.message}</Label> // Display error if validation fails
                )}                
              </FormGroup>
            </div>
            <div className={this.state.subject == followUpSubjects.followUpPhoneCall && this.state.time ? "col-md-6" : ""}>
              {this.state.subject && (this.state.subject == followUpSubjects.followUpReminder || this.state.subject == followUpSubjects.followUpPhoneCall) && ( 
                <FormGroup>
                <Label for="exampleSelect">Time Duration</Label>
                <Input
                className="input-date-filter remove-bottom-margin"
                type="select"
                name="timeDuration"
                required={true}
                onChange={this.handleInputChange}
                id="exampleSelect"
                value={this.state.timeDuration}
              >
              <option value="">Select Time Duration</option>
              <option value="One Week">One Week</option>
              <option value="Two Weeks">Two Weeks</option>
              <option value="One Month">One Month</option>
              <option value="Custom Date">Custom Date</option>
              </Input>
              </FormGroup>
              )}
            </div>
            </div>

              {/* Device image display */}
              {(this.state.deviceModel && this.state.deviceModel.length > 0) && (
                <div className="device-images-section">
                  <div className="device-images-header">
                    <i className="mdi mdi-devices" style={{ marginRight: 8, color: '#1e88e5' }}></i>
                    Selected Devices 
                    <span className="badge badge-info">{this.state.deviceModel.length}</span>
                  </div>
                  <div className="device-images-container">
                    {this.state.deviceModel.map((item) => (
                      <DeviceImageItem 
                        key={item.device._id}
                        device={item.device}
                        isSelected={true}
                        onClick={() => {}}
                        onImageError={() => {}}
                      />
                    ))}
                  </div>
                </div>
              )}
              {(this.state.subject == "64620873b1cebb9c4d5b70ea" ||
                this.state.subject == "646208d0b1cebb9c4d5b70eb" ||
                this.state.subject == "64f02ecb6d9efff481a93e67" ||
                this.state.subject == "646208d3b1cebb9c4d5b70ec" ||
                this.state.subject == "646208d6b1cebb9c4d5b70ed" ||
                this.state.subject == "64620ebdb1cebb9c4d5b70f7" || 
                this.state.subject == "64c781a345daedcb3562a359" || 
                this.state.subject == "64c781b245daedcb3562a35a" ||
                this.state.subject == "65081c5b4e8e9173654eb40b" ||
                this.state.subject == "65081cba4e8e9173654eb40c" ||
                this.state.subject == "650a77061e37821fe76376dc" || 
                this.state.subject == "673b0d7cddc94130af8d513e" ||
                this.state.subject == "6705158ac1d421c2143a8632" ||
                this.state.subject == "673b0d0295dac2bd8a709055" ||
                this.state.subject == "675c1a1295826b52e5e689ed" ||
                this.state.subject === ScheduledAndUnScheduledId.scheduled || 
                this.state.subject === ScheduledAndUnScheduledId.unScheduled) && !this.props.ongoingRequestDevice && !this.props.isNotApplicable && this.props.onBoarding && this.props.onBoarding.length > 0 && (
                  <>


                  <FormGroup className="remove-bottom-margin form-group-patient">
                    <Label for="examplePassword">
                      <i className="mdi mdi-devices" style={{ marginRight: 8, color: '#1e88e5' }}></i>
                      Select Shipment Device:&nbsp;&nbsp;
                    </Label>
                    
                    {/* Device Selection with Visual Gallery */}
                    {this.props.mDeviceListOnBoarding && this.props.mDeviceListOnBoarding.length > 0 && (
                      <>
                        <Select
                          options={this.props.mDeviceListOnBoarding.map(option => ({ 
                            label: option.device.name + ((option.lastCategory && option.lastCategory == '673b0d7cddc94130af8d513e' || option.lastCategory && option.lastCategory == '675c1a1295826b52e5e689ed') ? '(EHR)' : ''), 
                            value: option.device.serial ? option.device.serial : option.device._id
                          }))}
                          isMulti={true}
                          onChange={(selectedOption) => {
                            const fullObjects = selectedOption ? selectedOption.map(sel => this.props.mDeviceListOnBoarding.find(option => option.device._id === sel.value || option.device.serial === sel.value)).filter(Boolean) : [];
                            this.setState({
                              deviceModel: fullObjects,
                              errorDeviceModel: false
                            });
                          }}
                          value={this.state.deviceModel ? this.state.deviceModel.map(obj => ({ 
                            label: obj.device.name, 
                            value: obj.device.serial ? obj.device.serial : obj.device._id
                          })) : []}
                          isSearchable={true}
                          isClearable={true}
                          styles={{
                            container: (provided) => ({
                              ...provided,
                              width: '100%',
                            }),
                            option: (provided) => ({
                              ...provided,
                              whiteSpace: 'normal',
                              wordWrap: 'break-word',
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          placeholder="Search and select devices..."
                        />
                      </>
                    )}
                  </FormGroup>
                  {this.props.onBoarding && this.props.onBoarding.length != 0 && this.props.mDeviceListOnBoarding && this.props.mDeviceListOnBoarding == 0 && (
                    <Label style={{ 
                      color: "red",
                      padding:"10px 0px 0px 5px"
                     }}>Device not available for the selected category.</Label>
                  )}                  
                  {this.props.onBoarding && this.props.onBoarding.length > 0 && this.state.errorDeviceModel && (
                    <Label style={{
                      color: "red",
                      padding:"10px 0px 0px 5px"
                     }}>Please select device</Label>
                  )}
                  </>
                )}
                {this.props.ongoingRequestDevice && (
                  <LottieLoader
                    loadLoop={true}
                    autoplayLoop={true}
                    source={lottieLoaderFile}
                    Lheight={50}
                    Lwidth={50}
                    subTitleExtraSmall={"Please Wait ..."}
                  />
                )}
                {(this.state.subject == "64620873b1cebb9c4d5b70ea" ||
                this.state.subject == "646208d0b1cebb9c4d5b70eb" ||
                this.state.subject == "64f02ecb6d9efff481a93e67" ||
                this.state.subject == "646208d3b1cebb9c4d5b70ec" ||
                this.state.subject == "646208d6b1cebb9c4d5b70ed" ||
                this.state.subject == "64620ebdb1cebb9c4d5b70f7" || 
                this.state.subject == "64c781a345daedcb3562a359" || 
                this.state.subject == "64c781b245daedcb3562a35a" ||
                this.state.subject == "65081c5b4e8e9173654eb40b" ||
                this.state.subject == "65081cba4e8e9173654eb40c" ||
                this.state.subject == "650a77061e37821fe76376dc" ||
                this.state.subject == "667aa0e00bc7bcfe6b65aa0e" ||
                this.state.subject == "6705158ac1d421c2143a8632" || 
                this.state.subject == "673b0d7cddc94130af8d513e" ||
                this.state.subject == "673b0d0295dac2bd8a709055" ||
                this.state.subject == "675c171c95826b52e5e689ec" ||
                this.state.subject == "675c1a1295826b52e5e689ed" ||
                this.state.subject == "6911b697c4084353e779ac5c" ||
                this.state.subject == "6911b7dfc4084353e779ac5e") && !this.props.ongoingRequestDevice && this.props.onBoarding && this.props.onBoarding.length == 0 && this.props.displayLabel && (
                  <>
                  <div>
                  <LottieLoader
                    loadLoop={false}
                    autoplayLoop={true}
                    source={lottieWarningFile}
                    Lheight={75}
                    Lwidth={75}                    
                  />
                  <Label style={{ 
                    color: "red"
                    }}> Shipment category <b>{this.props.displayLabel}</b> is not available! Please include a category for <b>{this.props.displayLabel}</b>!</Label>
                  </div>
                  </>
                )}
                {(this.state.subject == "64620873b1cebb9c4d5b70ea" ||
                  this.state.subject == "646208d0b1cebb9c4d5b70eb" ||
                  this.state.subject == "64f02ecb6d9efff481a93e67" ||
                  this.state.subject == "646208d3b1cebb9c4d5b70ec" ||
                  this.state.subject == "646208d6b1cebb9c4d5b70ed" ||
                  this.state.subject == "64620ebdb1cebb9c4d5b70f7" || 
                  this.state.subject == "64c781a345daedcb3562a359" || 
                  this.state.subject == "64c781b245daedcb3562a35a" ||
                  this.state.subject == "65081c5b4e8e9173654eb40b" ||
                  this.state.subject == "65081cba4e8e9173654eb40c" ||
                  this.state.subject == "650a77061e37821fe76376dc" ||
                  this.state.subject == "667aa0e00bc7bcfe6b65aa0e" ||
                  this.state.subject == "6705158ac1d421c2143a8632" ||
                  this.state.subject == "673b0d7cddc94130af8d513e" ||
                  this.state.subject == "673b0d0295dac2bd8a709055" ||
                  this.state.subject == "675c171c95826b52e5e689ec" ||
                  this.state.subject == "675c1a1295826b52e5e689ed" ||
                  this.state.subject == "6911b697c4084353e779ac5c" ||
                  this.state.subject == "6911b7dfc4084353e779ac5e") && (
                  <>                  
                  <FormGroup style={{ marginTop: 10 }}>
                    <Label for="exampleText">Title</Label>
                    <Input
                      type="text"
                      name="title"
                      className="input-date-filter remove-bottom-margin"
                      required={true}
                      disabled={true}
                      onChange={this.handleInputChange}
                      value={this.state.title}
                      rows={1}
                      style={{textOverflow : 'ellipsis'}}
                    />
                  </FormGroup>
                  </>
                )}
                {this.state.timeDuration && this.state.timeDuration == "Custom Date" && this.state.subject && (this.state.subject == followUpSubjects.followUpReminder || this.state.subject == followUpSubjects.followUpPhoneCall || this.state.subject === ScheduledAndUnScheduledId.scheduled || this.state.subject == ScheduledAndUnScheduledId.unScheduled) && (
                  <div>
                    <FormGroup className="remove-bottom-margin form-group-patient">
                      <Label for="exampleDate">{this.state.subject === ScheduledAndUnScheduledId.scheduled || this.state.subject == ScheduledAndUnScheduledId.unScheduled ? 'Select a Schedule Date' : 'Select a Date'}</Label>
                      <Input
                        className="input-date-filter remove-bottom-margin"
                        type="date"
                        name="reminderDate"
                        min={moment().format("YYYY-MM-DD")}
                        onChange={this.handleInputReminderDateChange}
                        value={this.state.reminderDate}
                        required={this.state.timeDuration == "Custom Date" ? true : false}
                      />
                      <Label
                        style={{
                          color: "red",
                          textAlign: "left",
                          padding: 5
                        }}>{this.state.reminderDateError}</Label>
                    </FormGroup>
                  </div>
                )}
                <div className={this.state.subject == followUpSubjects.followUpPhoneCall && this.state.time ? "row" : ""}>
                <div className={this.state.subject == followUpSubjects.followUpPhoneCall && this.state.time ? "col-md-6" : ""}>
                {this.state.timeDuration && (this.state.subject == followUpSubjects.followUpReminder || this.state.subject == followUpSubjects.followUpPhoneCall || this.state.subject === ScheduledAndUnScheduledId.scheduled) && (<FormGroup>
                  <Label for="exampleReminder">Pick a Specific Time for Reminders</Label>
                    <Datetime
                      dateFormat={false}
                      inputProps={{
                        placeholder: "Input Desired Time",
                        required: this.state.timeDuration && (this.state.subject == followUpSubjects.followUpReminder || this.state.subject == followUpSubjects.followUpPhoneCall || this.state.subject === ScheduledAndUnScheduledId.scheduled) ? true : false
                      }}
                      onChange={(event) =>
                        this.handleTimeChange(event)
                      }
                      value={this.state.time}
                    />
                  {this.state.timeError && (<Label
                    style={{
                      color: "red",
                      textAlign: "left",
                      padding: 5,
                      'marginBottom' : '-6px'
                    }}>{this.state.timeError}</Label>)}
                </FormGroup>)}
                </div>
                <div className={this.state.subject == followUpSubjects.followUpPhoneCall && this.state.time ? "col-md-6" : ""}>
                {this.state.timeDuration && (this.state.subject == followUpSubjects.followUpReminder || this.state.subject == followUpSubjects.followUpPhoneCall || this.state.subject === ScheduledAndUnScheduledId.scheduled || this.state.subject == ScheduledAndUnScheduledId.unScheduled) && (<FormGroup>
                  <Label for="exampleSelect">Notify Me</Label>
                  <div>
                    <CustomInput
                      type="checkbox"
                      id="exampleCustomInline7"
                      name="notifyMe"
                      onChange={this.handelSelectChange}
                      label="SMS"
                      value="Sms"
                      inline
                      checked={this.state.notifyMe.includes('Sms')}
                    />
                    <CustomInput
                      type="checkbox"
                      id="exampleCustomInline9"
                      name="notifyMe"
                      onChange={this.handelSelectChange}
                      label="EMAIL"
                      value="Email"
                      inline
                      checked={this.state.notifyMe.includes('Email')}
                    />
                    <Alert color="success">
                      By default the reminder will be sent to Inbox
                    </Alert>
                  </div>
                </FormGroup>)}
                </div>
                </div>
                {this.state.subject == "Other" && (
                  <FormGroup>
                    <Input
                      type="text"
                      name="customSubject"
                      className="input-date-filter remove-bottom-margin"
                      placeholder="Please specify"
                      required={true}
                      onChange={this.handleInputChange}
                      rows={10}
                    />
                  </FormGroup>
                )}
                <FormGroup>
                  <Label for="exampleText">Message</Label>
                  <Input
                    type="textarea"
                    className="input-date-filter remove-bottom-margin"
                    name="body"
                    onChange={this.handleInputChange}
                    value={this.state.body}
                    rows={this.state.subject == followUpSubjects.followUpPhoneCall && this.state.time ? 4 : 10}
                  />
                  {this.state.error && this.state.error.type == 'body' && !this.state.body && (
                    <Label
                    style={{
                      color: "red",
                      textAlign: "left",
                      paddingTop: '3px'
                    }}>{this.state.error.message}</Label> // Display error if validation fails
                  )}    
                </FormGroup>
                {(this.state.subject == followUpSubjects.followUpPhoneCall) && this.state.time && (<>
                <div className="row">
                {this.state.reminderDate && moment().add(1, 'day').isBefore(moment(this.state.reminderDate).set({hour:moment(this.state.time).hour(),minute:moment(this.state.time).minutes(),second:0,millisecond:0})) && (
                <div className="col-md-6">
                  <>
                  <FormGroup>
                    <Label for="exampleText">Patient Reminder Message: 1 Day Before Call</Label>
                    <Input
                      type="textarea"
                      className="input-date-filter remove-bottom-margin mb-3"
                      name="oneDayRemindMessgae"
                      onChange={this.handleInputChange}
                      value={this.state.oneDayRemindMessgae}
                      rows={3}
                      style={{ lineHeight: '1.4', fontSize : '17px' }}
                      required
                    />
                  </FormGroup>  
                  </>
                </div>
                )}
                <div className="col-md-6">
                <FormGroup>
                  <Label for="exampleText">Patient Reminder Message: 1 Hour Before Call</Label>
                  <Input
                    type="textarea"
                    className="input-date-filter remove-bottom-margin mb-3"
                    name="oneHourRemindMessgae"
                    onChange={this.handleInputChange}
                    value={this.state.oneHourRemindMessgae}
                    rows={3}
                    style={{ lineHeight: '1.4', fontSize : '17px' }}
                    required
                  />
                  </FormGroup>
                </div>
                {this.state.reminderDate && moment().startOf('day').add(1, 'day').add(12, 'hours').isBefore(moment(this.state.reminderDate).startOf('day').set({hour:moment(this.state.time).hour(),minute:moment(this.state.time).minutes(),second:0,millisecond:0})) && (<div className="col-md-6">
                  <FormGroup>
                  <Label for="exampleText">Your Reminder Message at 8:00 AM (America/New_York){this.state.reminderDate ? ' on ' + moment(`${this.state.reminderDate}`).format('MM/DD/YYYY') : ''}</Label>
                  <Input
                    type="textarea"
                    className="input-date-filter remove-bottom-margin mb-3"
                    name="reminderEightAmUtcTodayMessage"
                    onChange={this.handleInputChange}
                    value={this.state.reminderEightAmUtcTodayMessage}
                    rows={3}
                    style={{ lineHeight: '1.4', fontSize : '17px' }}
                    required
                  />
                  </FormGroup>
                </div>)}
                <div className="col-md-6">
                  <FormGroup>
                  <Label for="exampleText">Your Reminder Message: At the Time Call</Label>
                  <Input
                    type="textarea"
                    className="input-date-filter remove-bottom-margin mb-3"
                    name="atTheTimeRemindMessage"
                    onChange={this.handleInputChange}
                    value={this.state.atTheTimeRemindMessage}
                    rows={3}
                    style={{ lineHeight: '1.4', fontSize : '17px' }}
                    required
                  />
                  </FormGroup>
                </div>
                </div>
                </>)}
                {!this.props.hideNotesButton && (
                  <FormGroup>
                    <Label for="defaultCheck1" className="form-check-label pr-4">
                      Public Note?
                    </Label>
                    <Input
                      type="checkbox"
                      id="defaultCheck1"
                      name="isPublic"
                      className="form-check-input mt-0"
                      checked={this.state.isPublic}
                      disabled={this.state.hidePublicNotes}
                      onChange={this.handleInputChange}
                      rows={10}
                    />
                  </FormGroup>
                )}
              <button type="submit" class="btn btn-block btn-info save-click-cls">
              <i class="mdi mdi-content-save"></i> Send
              </button>
            </Form>
          </ModalBody>
        </Modal>
        <SweetAlert
          error
          title={this.props.genericErrorMessage.message}
          show={this.props.isGenericError}
          onConfirm={() => {
            this.props.dispatch({
              type: "GENERIC_ERROR"
            });
          }}
          confirmBtnBsStyle="danger"
          timeout={1000}
        />
      </div>
    );
  }
}

function mapStateToProps({ careprovider, user }) {
  const { 
    notes,
    onBoardingStatus,
    isNotApplicable,
    displayLabel,
    onBoarding,
    ongoingRequest,
    ongoingRequestDevice,
    ongoingNoteListRequest,
    notesPatientDetails,
    rpmTotalDuration,
    ccmTotalDuration,
    mDeviceListOnBoarding,
    latestReadingUser, isGenericSuccess, isGenericError, genericErrorMessage } =
    careprovider;
  const isCareProvider = user.userDetails.isCareProvider;
  const currentUserDetails = user.userDetails;
  return {
    notes,
    onBoardingStatus,
    onBoarding,
    mDeviceListOnBoarding,
    isNotApplicable,
    displayLabel,
    ongoingRequest,
    ongoingRequestDevice,
    notesPatientDetails,
    latestReadingUser,
    isCareProvider,
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    ongoingNoteListRequest,
    rpmTotalDuration,
    ccmTotalDuration,
    currentUserDetails
  };
}
export default connect(mapStateToProps)(Notes);
